import { render, staticRenderFns } from "./TempReport.vue?vue&type=template&id=c5635468&scoped=true&"
import script from "./TempReport.vue?vue&type=script&lang=js&"
export * from "./TempReport.vue?vue&type=script&lang=js&"
import style0 from "./TempReport.vue?vue&type=style&index=0&id=c5635468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5635468",
  null
  
)

export default component.exports